/**
 * Rotating announcement bar — fade between messages, sticky height sync, CTR tracking.
 */
(function () {
  const root = document.getElementById('AnnouncementBar');
  if (!root) return;

  const INTERVAL_MS = Math.min(
    7000,
    Math.max(5000, Number(root.dataset.rotationSpeed) || 6000)
  );
  const slides = Array.from(root.querySelectorAll('[data-announcement-slide]'));
  const prefersReducedMotion = window.matchMedia(
    '(prefers-reduced-motion: reduce)'
  ).matches;

  function setAnnouncementHeight() {
    const height = root.getBoundingClientRect().height;
    document.documentElement.style.setProperty(
      '--announcement-bar-height',
      `${height}px`
    );
  }

  setAnnouncementHeight();
  window.addEventListener('resize', setAnnouncementHeight);

  function trackClick(el) {
    const payload = {
      message: (el.dataset.announcementMessage || el.textContent || '')
        .trim()
        .slice(0, 80),
      index: el.dataset.announcementIndex || '',
      link: el.getAttribute('href') || '',
    };

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'announcement_bar_click',
      ...payload,
    });

    if (window.Shopify?.analytics?.publish) {
      try {
        window.Shopify.analytics.publish('announcement_bar_click', payload);
      } catch (e) {
        /* no-op */
      }
    }
  }

  root.querySelectorAll('[data-announcement-link]').forEach((el) => {
    el.addEventListener('click', () => trackClick(el));
  });

  if (slides.length < 2 || prefersReducedMotion) {
    if (slides[0]) slides[0].classList.add('is-active');
    return;
  }

  let current = 0;
  let timer = null;
  let paused = false;

  slides.forEach((slide, i) => {
    slide.classList.toggle('is-active', i === 0);
    slide.setAttribute('aria-hidden', i === 0 ? 'false' : 'true');
  });

  function goTo(next) {
    slides[current].classList.remove('is-active');
    slides[current].setAttribute('aria-hidden', 'true');
    current = next;
    slides[current].classList.add('is-active');
    slides[current].setAttribute('aria-hidden', 'false');
  }

  function nextSlide() {
    if (paused) return;
    goTo((current + 1) % slides.length);
  }

  function start() {
    stop();
    timer = window.setInterval(nextSlide, INTERVAL_MS);
  }

  function stop() {
    if (timer) {
      window.clearInterval(timer);
      timer = null;
    }
  }

  root.addEventListener('mouseenter', () => {
    paused = true;
  });
  root.addEventListener('mouseleave', () => {
    paused = false;
  });
  root.addEventListener('focusin', () => {
    paused = true;
  });
  root.addEventListener('focusout', () => {
    paused = false;
  });

  document.addEventListener('visibilitychange', () => {
    if (document.hidden) stop();
    else start();
  });

  start();
})();
